// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"1142fab1","453":"ff676687","732":"95fabbba"}[chunkId] + ".chunk.js";
};